export const sessionQrConnections = {
    namespaced: true,

    state: {
        crew: [],
        crews: []
    },

    getters: {
        getCrew(state) {
            return state.crew;
        },

        getCrews(state) {
            return state.crews;
        }
    },

    mutations: {
        resetCrew(state) {
            state.crew = [];
        },

        resetCrews(state) {
            state.crews = [];
        },

        setCrew(state, payload) {
            state.crew.push(payload);
        },

        setCrews(state, payload) {
            state.crews = payload;
        }
    }
};

export default sessionQrConnections;
